define(['angular'], function(angular) {


    function StoresGroupProvider() {
        var bdcUrl;

        this.setBDCUrl = function setBDCUrl(url) {
            bdcUrl = url;
        };

        this.$get = [
            '$http',
            function($http) {
                var self = {};

                /**
                 * Create or update a groups of stores
                 * @param  {Object} data
                 * @return {Promise}
                 */
                self.createUpdate = function createUpdate(data) {
                    return $http.put(bdcUrl + 'storesGroup/createOrUpdate', data).then(function(res) {
                        return res.data;
                    });
                };

                self.delete = function(id){
                    return $http.delete(bdcUrl + 'storesGroup/delete/' + id).then(function(res) {return res.data;});
                }

                return self;
            }
        ];
    }

    angular.module('app.bdc.common.storesGroupProvider', []).provider('storesGroup', StoresGroupProvider);
});
